import { render } from "./PreloaderComp.vue?vue&type=template&id=5013c9a0&scoped=true"
import script from "./PreloaderComp.vue?vue&type=script&lang=js"
export * from "./PreloaderComp.vue?vue&type=script&lang=js"

import "./PreloaderComp.vue?vue&type=style&index=0&id=5013c9a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5013c9a0"]])

export default __exports__